<template>
    <modal
        :title="title"
        :description="description"
        @close="$emit('close')">
        <template :slot="'header-top'">
            <img :src="icon" alt="org" class="w-16 md:w-20 py-6 m-auto text-center">
        </template>
        <template :slot="'header-bottom'">
            <score-bar :score="score" size="lg"/>
        </template>
        <template>
            <vue-glide
                    v-if="slides.length"
                    :type="'carousel'"
                    :per-view="1"
                    :gap="0"
                    v-model="active"
                    class="pb-6">
                <vue-glide-slide
                        v-for="(slide, index) in slides"
                        :key="`slide_${index}`"
                        v-html="slide"/>

                <template slot="control">
                    <div v-for="(slide, index) in slides"
                         :key="`dot_${index}`"
                         :data-glide-dir="`=${index}`"
                         :class="active === index ? 'bg-primary-100' : 'bg-lightGreen-200'"
                         class="w-3 h-3 mx-2 cursor-pointer rounded-full inline-block"></div>
                </template>
            </vue-glide>
        </template>
    </modal>
</template>

<script>
    import Modal from './Modal';
    import ScoreBar from './ScoreBar';
    import { Glide, GlideSlide } from 'vue-glide-js'

    export default {
        props: {
            icon: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: null
            },
            description: {
                type: String,
                default: null
            },
            score: {
                type: Number,
                default: 0
            },
            slides: {
                type: Array,
                default: () => []
            }
        },

        components: {
            Modal,
            ScoreBar,
            [Glide.name]: Glide,
            [GlideSlide.name]: GlideSlide
        },

        data() {
            return {
                active: 0
            }
        },
    }
</script>

<style lang="scss" scoped>
    .glide__slide {
        transform: none;

        @media only screen and (max-width: 1023px) {
            padding: 40px 0;
        }

        @media only screen and (max-width: 768px) {
            padding: 20px 0 40px;
        }

        &:after,
        &:before {
            display: none;
        }

        &.glide__slide--active {
            box-shadow: none;
            transform: none;
            padding: 40px;

            @media only screen and (max-width: 1023px) {
                padding: 40px 0;
            }

            @media only screen and (max-width: 768px) {
                padding: 20px 0 40px;
            }
        }
    }
</style>
